import { render, staticRenderFns } from "./CotationTable.vue?vue&type=template&id=2bc39bb3&"
import script from "./CotationTable.vue?vue&type=script&lang=js&"
export * from "./CotationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports